import { pipe } from 'ramda';

import {
  buildCmsUrl,
  CMSApiBase,
  CMSDescription,
  CMSFaq,
  CMSHowToParticipate,
  CMSImageBase,
  getResponseCMS,
} from './base';
import { request } from '@/api/base';
import { getResponseCamelization } from '@/helpers/api';

export interface FortuneWheelMenuDataApi extends CMSApiBase {
  menu: {
    bg: CMSImageBase;
    character: CMSImageBase;
  };
}

export const fortuneWheelMenuCMS = (lang: string) =>
  request<FortuneWheelMenuDataApi>({
    url: buildCmsUrl({
      path: 'fortune-wheel',
      lang,
      additionalParams: {
        'populate[0]': 'menu',
        'populate[1]': 'menu.bg',
        'populate[2]': 'menu.character',
      },
    }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<FortuneWheelMenuDataApi>
    ),
  });

export interface FortuneWheelApi extends CMSApiBase {
  pageTitle: string;
  description: CMSDescription[];
  howToParticipateTitle: string;
  leftCharacter: CMSImageBase;
  rightCharacter: CMSImageBase;
  mobileCharacter: CMSImageBase;
  leftDecor: CMSImageBase;
  rightDecor: CMSImageBase;
  wheelArrow: CMSImageBase;
  topBg: CMSImageBase;
  howToParticipate: CMSHowToParticipate[];
  faq: CMSFaq[];
  bonusBuyPromocode?: string;
}

export const fortuneWheelCMS = (lang: string) =>
  request<FortuneWheelApi>({
    url: buildCmsUrl({
      path: 'fortune-wheel',
      lang,
      additionalParams: { populate: 'deep' },
    }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<FortuneWheelApi>
    ),
  });

export interface FortuneWheelPageTitleApi extends CMSApiBase {
  pageTitle: string;
}

export const fortuneWheelPageTitleCMS = (lang: string) =>
  request<FortuneWheelPageTitleApi>({
    url: buildCmsUrl({
      path: 'fortune-wheel',
      lang,
      additionalParams: {
        fields: 'page_title',
      },
    }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<FortuneWheelPageTitleApi>
    ),
  });
